import { canUseDOM } from '../../components';

export const FETCH_DEACTIVATION_ALERTS_CLIENT = 'FETCH_DEACTIVATION_ALERTS_CLIENT';
export const FETCH_DEACTIVATION_ALERTS = 'FETCH_DEACTIVATION_ALERTS';
export const FETCH_DEACTIVATION_ALERTS_START = 'FETCH_DEACTIVATION_ALERTS_START';
export const FETCH_DEACTIVATION_ALERTS_SUCCESS = 'FETCH_DEACTIVATION_ALERTS_SUCCESS';
export const FETCH_DEACTIVATION_ALERTS_ERROR = 'FETCH_DEACTIVATION_ALERTS_ERROR';

const fetchFn = (fetch, url, verb, params) => fetch(url, {
  method: verb,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Connection: 'keep-alive',
  },
  body: JSON.stringify(params),
  credentials: 'same-origin',
});

export function fetchDeactivationAlerts(params) {
  if (canUseDOM) {
    return () => ({
      type: FETCH_DEACTIVATION_ALERTS_CLIENT,
    });
  }
  const url = '/portal-srp/api/v1/deactivation-alerts';
  const verb = 'POST';
  const body = {
    site: params.apireq.site, 
    domain: params.domain, 
    locale: params.locale, 
    apireq: params.apireq, 
    baseUri: params.uri,
  };
  return ({ fetch }) => ({
    type: FETCH_DEACTIVATION_ALERTS,
    payload: {
      promise: fetchFn(fetch, url, verb, body)
        .then(response => response.json())
        .catch(err => console.error('Error fetch deactivation-alerts', err)),
    },
  });
}
